import Navigator from "./pages/Navigator"

function App() {
  return (
    <>
      <Navigator />
    </>
  )
}

export default App
